import { useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { cn } from "../lib/utils";

// Junior / Senior only changes typing lessons, typing games and pixel art, so the switch lives on those pages (not in the menu).
const AGE_PAGES = /^\/(lessons?|games?)(\/|$)|^\/pixel-trial/;

export function AgeBar() {
  const { t, lang, age, setAge } = useApp();
  const { pathname } = useLocation();
  if (!AGE_PAGES.test(pathname)) return null;
  const btn = (id) => <button type="button" data-testid={`age-${id}`} aria-pressed={age === id} onClick={() => setAge(id)}
    className={cn("px-3 py-1 rounded-full text-sm font-bold transition-all", age === id ? "bg-teal-600 text-white shadow-sm" : "text-slate-500 hover:text-slate-800")}>{t(id)}</button>;
  return (
    <div className="flex justify-end mb-3" data-testid="age-bar">
      <div role="group" aria-label={lang === "ar" ? "المستوى" : "Level"} className="inline-flex items-center gap-0.5 bg-slate-100 rounded-full p-0.5">
        <span className="ps-2.5 pe-1 text-xs font-bold text-slate-500">{lang === "ar" ? "المستوى" : "Level"}</span>{btn("junior")}{btn("senior")}
      </div>
    </div>
  );
}
